// Import everything from autoload folder
import './autoload/ada-compliance.js'; import './autoload/foundation.js'; // eslint-disable-line

// Import local dependencies
import './plugins/lazyload';
import './plugins/modernizr.min';
import 'slick-carousel';
import 'jquery-match-height';
import objectFitImages from 'object-fit-images';
import '@fancyapps/fancybox/dist/jquery.fancybox.min';
// import { jarallax, jarallaxElement } from 'jarallax';
// import ScrollOut from 'scroll-out';

/**
 * Import scripts from Custom Divi blocks
 */
// eslint-disable-next-line import/no-unresolved
//import '../blocks/divi/example-block/index.js';

/**
 * Import scripts from Custom Elementor widgets
 */
// eslint-disable-next-line import/no-unresolved
//import '../blocks/elementor/example-widget/index.js';

/**
 * Import scripts from Custom ACF Gutenberg blocks
 */
// eslint-disable-next-line import/no-unresolved
import '../blocks/gutenberg/acf-about-page-block/index.js'; import '../blocks/gutenberg/acf-contact-page-block/index.js'; import '../blocks/gutenberg/acf-cta-all-pages-block/index.js'; import '../blocks/gutenberg/acf-cta-block/index.js'; import '../blocks/gutenberg/acf-example-block/index.js'; import '../blocks/gutenberg/acf-hero-slider/index.js'; import '../blocks/gutenberg/acf-video-block/index.js';

/**
 * Init foundation
 */
$(document).foundation();

/**
 * Fit slide video background to video holder
 */
function resizeVideo() {
  let $holder = $('.videoHolder');
  $holder.each(function () {
    let $that = $(this);
    let ratio = $that.data('ratio') ? $that.data('ratio') : '16:9';
    let width = parseFloat(ratio.split(':')[0]);
    let height = parseFloat(ratio.split(':')[1]);
    $that.find('.video').each(function () {
      if ($that.width() / width > $that.height() / height) {
        $(this).css({
          width: '100%',
          height: 'auto',
        });
      } else {
        $(this).css({
          width: ($that.height() * width) / height,
          height: '100%',
        });
      }
    });
  });
}

/**
 * Scripts which runs after DOM load
 */
$(document).on('ready', function () {
  /**
   * Make elements equal height
   */
  $('.js-loadmore-btn').on('click', function (e) {
    e.preventDefault();

    var $btn = $(this);
    var step = parseInt($btn.data('step')) || 4;

    var $hiddenItems = $('.js-loadmore-container .home-cta__button.is-hidden');
    $hiddenItems.slice(0, step).removeClass('is-hidden');
    if ($('.js-loadmore-container .home-cta__button.is-hidden').length === 0) {
      $btn.parent().fadeOut();
    }
  });

  $(document).on('click', '.open-filter', function (e) {
    e.stopPropagation();

    $('.all-filter .facetwp-facet').toggleClass('active');
    $('.open-filter').toggleClass('active');
    $('.all-filter ').toggleClass('active');
    var selectEl = $('.all-filter select.facetwp-dropdown')[0];

    if (selectEl && typeof selectEl.showPicker === 'function') {
      selectEl.showPicker();
    } else if (selectEl) {
      selectEl.focus();
    }
  });

  $(document).on('change', '.all-filter select.facetwp-dropdown', function () {
    $('.all-filter .facetwp-facet, .open-filter, .all-filter').removeClass(
      'active'
    );
  });
  $(document).on('facetwp-loaded', function () {
    $('.all-filter .facetwp-facet, .open-filter, .all-filter').removeClass(
      'active'
    );
  });

  $('.matchHeight').matchHeight();

  /**
   * IE Object-fit cover polyfill
   */
  if ($('.of-cover').length) {
    objectFitImages('.of-cover');
  }

  /**
   * Add fancybox to images
   */
  // $('.gallery-item')
  //   .find('a[href$="jpg"], a[href$="png"], a[href$="gif"]')
  //   .attr('rel', 'gallery')
  //   .attr('data-fancybox', 'gallery');
  // $(
  //   '.fancybox, a[rel*="album"], a[href$="jpg"], a[href$="png"], a[href$="gif"]'
  // ).fancybox({
  //   minHeight: 0,
  //   helpers: {
  //     overlay: {
  //       locked: false,
  //     },
  //   },
  // });

  /**
   * Init parallax
   */
  // jarallaxElement();
  // jarallax(document.querySelectorAll('.jarallax'), {
  //   speed: 0.5,
  // });

  /**
   * Detect element appearance in viewport
   */
  // ScrollOut({
  //   offset: function() {
  //     return window.innerHeight - 200;
  //   },
  //   once: true,
  //   onShown: function(element) {
  //     if ($(element).is('.ease-order')) {
  //       $(element)
  //         .find('.ease-order__item')
  //         .each(function(i) {
  //           let $this = $(this);
  //           $(this).attr('data-scroll', '');
  //           window.setTimeout(function() {
  //             $this.attr('data-scroll', 'in');
  //           }, 300 * i);
  //         });
  //     }
  //   },
  // });

  /**
   * Remove placeholder on click
   */
  const removeFieldPlaceholder = () => {
    $('input, textarea').each((i, el) => {
      $(el)
        .data('holder', $(el).attr('placeholder'))
        .on('focusin', () => {
          $(el).attr('placeholder', '');
        })
        .on('focusout', () => {
          $(el).attr('placeholder', $(el).data('holder'));
        });
    });
  };

  removeFieldPlaceholder();

  $(document).on('gform_post_render', () => {
    removeFieldPlaceholder();
  });

  /**
   * Scroll to Gravity Form confirmation message after form submit
   */
  $(document).on('gform_confirmation_loaded', function (event, formId) {
    let $target = $('#gform_confirmation_wrapper_' + formId);
    if ($target.length) {
      $('html, body').animate({ scrollTop: $target.offset().top - 50 }, 500);
      return false;
    }
  });

  /**
   * Hide gravity forms required field message on data input
   */
  $('body').on(
    'change keyup',
    '.gfield input, .gfield textarea, .gfield select',
    function () {
      let $field = $(this).closest('.gfield');
      if ($field.hasClass('gfield_error') && $(this).val().length) {
        $field.find('.validation_message').hide();
      } else if ($field.hasClass('gfield_error') && !$(this).val().length) {
        $field.find('.validation_message').show();
      }
    }
  );

  /**
   * Add `is-active` class to menu-icon button on Responsive menu toggle
   * And remove it on breakpoint change
   */
  $(window)
    .on('toggled.zf.responsiveToggle', function () {
      $('.menu-icon').toggleClass('is-active');
    })
    .on('changed.zf.mediaquery', function () {
      $('.menu-icon').removeClass('is-active');
    });

  /**
   * Close responsive menu on orientation change
   */
  $(window).on('orientationchange', function () {
    setTimeout(function () {
      if ($('.menu-icon').hasClass('is-active') && window.innerWidth < 641) {
        $('[data-responsive-toggle="main-menu"]').foundation('toggleMenu');
      }
    }, 200);
  });

  resizeVideo();

  /* 360 Slider */
  /* 360 Slider */
  const $container = $('#product-360-container');
  if (!$container.length) return;

  // Змінні кадрів робимо let, щоб вони динамічно перезаписувалися при зміні 360° групи
  let $frames = $container.find(
    '.product-360-view__frames:visible .product-360-view__frame'
  );
  if (!$frames.length) {
    $frames = $container.find('.product-360-view__frame');
  }
  let totalFrames = $frames.length;

  let currentFrame = 0;
  let isDragging = false;
  let startX = 0;
  let autoRotateInterval = null;

  function preloadImages() {
    $container.find('.product-360-view__frame').each(function () {
      const $img = $(this);
      const src = $img.attr('src');

      if (src) {
        const img = new Image();
        img.src = src;

        if (img.decode) {
          img.decode().catch(function () {});
        }
      }
    });
  }

  preloadImages();

  const $prevBtn = $container.find('.prev-btn');
  const $nextBtn = $container.find('.next-btn');
  const $playBtn = $container.find('.play-btn');
  const $iconPlay = $container.find('.icon-play');
  const $iconPause = $container.find('.icon-pause');

  function showFrame(index) {
    if (!totalFrames) return;
    $frames.eq(currentFrame).removeClass('is-active');
    currentFrame = (index + totalFrames) % totalFrames;
    $frames.eq(currentFrame).addClass('is-active');
  }

  function nextFrame() {
    showFrame(currentFrame + 1);
  }

  function prevFrame() {
    showFrame(currentFrame - 1);
  }

  function handleStart(e) {
    isDragging = true;
    startX =
      e.pageX || (e.originalEvent.touches && e.originalEvent.touches[0].pageX);
    stopAutoRotate();
  }

  function handleMove(e) {
    if (!isDragging) return;
    const currentX =
      e.pageX || (e.originalEvent.touches && e.originalEvent.touches[0].pageX);
    const diff = startX - currentX;

    if (Math.abs(diff) > 10) {
      if (diff > 0) {
        nextFrame();
      } else {
        prevFrame();
      }
      startX = currentX;
    }
  }

  function handleEnd() {
    isDragging = false;
  }

  $container.on(
    'mousedown touchstart',
    '.product-360-view__frames',
    handleStart
  );
  $(window).on('mousemove touchmove', handleMove);
  $(window).on('mouseup touchend', handleEnd);

  $prevBtn.on('click', function () {
    stopAutoRotate();
    prevFrame();
  });
  $nextBtn.on('click', function () {
    stopAutoRotate();
    nextFrame();
  });

  function startAutoRotate() {
    autoRotateInterval = setInterval(nextFrame, 80);
    $iconPlay.hide();
    $iconPause.show();
  }

  function stopAutoRotate() {
    if (autoRotateInterval) {
      clearInterval(autoRotateInterval);
      autoRotateInterval = null;
      $iconPlay.show();
      $iconPause.hide();
    }
  }

  $playBtn.on('click', function () {
    if (autoRotateInterval) {
      stopAutoRotate();
    } else {
      startAutoRotate();
    }
  });

  // --- Main Slider ---
  const $slider = $('.main-slider');
  const $viewContainer = $('#product-360-container');

  if (!$slider.length) return;

  const $syncControls = $viewContainer.find('.product-360-view__controls');

  let $dynamicMedia = $viewContainer.find('.product-360-view__dynamic-media');
  if (!$dynamicMedia.length) {
    $dynamicMedia = $(
      '<div class="product-360-view__dynamic-media none-background"></div>'
    ).hide();
    $viewContainer
      .find('.product-360-view__frames')
      .last()
      .after($dynamicMedia);
  } else {
    $dynamicMedia.addClass('none-background');
  }

  function showFrames(groupId) {
    groupId = groupId || '360-1';

    stopAutoRotate();
    $dynamicMedia.hide().empty();

    const $allGroups = $container.find('.product-360-view__frames');
    $allGroups.hide();

    let $activeGroup = $container.find(
      `.product-360-view__frames[data-360-group="${groupId}"]`
    );
    if (!$activeGroup.length) {
      $activeGroup = $allGroups.first();
    }

    if ($activeGroup.length) {
      $activeGroup.show();
      $frames = $activeGroup.find('.product-360-view__frame');
      totalFrames = $frames.length;
      currentFrame = 0;
      $frames.removeClass('is-active').eq(0).addClass('is-active');
    }

    $syncControls.show();
  }

  function showImage(src, alt) {
    stopAutoRotate();
    $container.find('.product-360-view__frames').hide();
    $syncControls.hide();
    $dynamicMedia
      .empty()
      .append(`<img src='${src}' alt='${alt || ''}'>`)
      .show();
  }

  function showVideo(videoId) {
    stopAutoRotate();
    $container.find('.product-360-view__frames').hide();
    $syncControls.hide();
    const embed = `
<div class='responsive-embed'>
  <iframe
    src='https://www.youtube.com/embed/${videoId}?rel=0&autoplay=1&mute=1'
    frameborder='0'
    allow='accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture'
    allowfullscreen>
  </iframe>
</div>`;
    $dynamicMedia.empty().append(embed).show();
  }

  function syncTopView($slide) {
    if (!$slide || !$slide.length) return;

    const $imgInSlide = $slide.find('img');
    if (
      $imgInSlide.length &&
      $imgInSlide.hasClass('main-slider__img--contain')
    ) {
      $dynamicMedia.css('background-color', 'transparent');
    } else {
      $dynamicMedia.css('background-color', '');
    }

    if ($slide.hasClass('slider-360')) {
      const groupId = $slide.attr('data-360-id') || '360-1';
      showFrames(groupId);
      $dynamicMedia.removeClass('image-container');
      return;
    }

    if ($slide.hasClass('main-slider__slide--video')) {
      const videoId = $slide.attr('data-video-id');
      $dynamicMedia.removeClass('image-container');
      if (videoId) showVideo(videoId);
      return;
    }

    if ($slide.hasClass('main-slider__slide--image')) {
      const $img = $slide.find('img').first();
      $dynamicMedia.addClass('image-container');
      if ($img.length) {
        showImage($img.attr('src'), $img.attr('alt'));
      }
    }
  }

  function markActive($slide) {
    $slider.find('.main-slider__slide').removeClass('is-selected');
    $slide.addClass('is-selected');
  }

  function syncByIndex(currentSlide) {
    const $activeSlide = $slider
      .find(`.slick-slide[data-slick-index="${currentSlide}"]`)
      .not('.slick-cloned')
      .find('.main-slider__slide');

    markActive($activeSlide);
    syncTopView($activeSlide);
  }

  $slider.on('init', function () {
    $slider.find('.slick-cloned iframe').each(function () {
      const currentSrc = $(this).attr('src');
      $(this).attr('src', currentSrc);
    });

    setTimeout(() => {
      $slider.slick('setPosition');
      syncByIndex($slider.slick('slickCurrentSlide'));
      $slider.addClass('is-loaded');
    }, 150);
  });

  $slider.on('afterChange', function (event, slick, currentSlide) {
    syncByIndex(currentSlide);

    const $activeSlide = $slider
      .find(`.slick-slide[data-slick-index="${currentSlide}"]`)
      .not('.slick-cloned')
      .find('.main-slider__slide');
    if ($activeSlide.hasClass('slider-360')) {
      $dynamicMedia.addClass('none-background');
    } else {
      $dynamicMedia.removeClass('none-background');
    }
  });

  $slider.slick({
    slidesToShow: 8,
    slidesToScroll: 1,
    dots: false,
    arrows: true,
    infinite: true,
    adaptiveHeight: false,
    responsive: [
      {
        breakpoint: 991,
        settings: {
          slidesToShow: 7,
        },
      },
    ],
  });

  $slider.on('click', '.main-slider__slide', function () {
    const slideIndex = $(this).closest('.slick-slide').data('slick-index');
    $slider.slick('slickGoTo', slideIndex);
  });

  $slider.find('iframe').on('load', function () {
    $slider.slick('setPosition');
  });

  $('body').on('click', 'a[href="#form"]', function (e) {
    e.preventDefault();
    e.stopPropagation();
    $('.contact__form').fadeToggle();
  });
  $('body').on('click', '.contact__form .close', function (e) {
    e.preventDefault();
    e.stopPropagation();
    $('.contact__form').fadeOut();
  });

  $(document).on('click', function (e) {
    if (!$(e.target).closest('.contact-form-wrap').length) {
      if ($('.contact__form').is(':visible')) {
        $('.contact__form').fadeOut();
      }
    }
  });

  $('body').on('click', '.contact-form-wrap', function (e) {
    e.stopPropagation();
  });
  $('.show-bottom-side').on('click', function (e) {
    e.preventDefault();
    $('.bottom-side').slideToggle();
  });
});

/**
 * Scripts which runs after all elements load
 */
$(window).on('load', function () {
  // jQuery code goes here

  let $preloader = $('.preloader');
  if ($preloader.length) {
    $preloader.addClass('preloader--hidden');
  }
});

/**
 * Scripts which runs at window resize
 */
$(window).on('resize', function () {
  // jQuery code goes here

  resizeVideo();
});

/**
 * Scripts which runs on scrolling
 */
$(window).on('scroll', function () {
  if ($(this).scrollTop() > 0) {
    $('header').addClass('is-scrolled');
  } else {
    $('header').removeClass('is-scrolled');
  }
});
